export default __webpack_public_path__ + "static/media/photo--sm--group-jump2.0f04ea30.jpg";